import { FeatureType } from '../types';

/**
 * Check if a project is a basic/starter project (no features)
 */
export const isBasicProject = (features: FeatureType[]): boolean => {
    return !features || features.length === 0;
};

/**
 * Check if a project has Insights feature (Species Insights / eDNA)
 */
export const hasInsightsFeature = (features: FeatureType[]): boolean => {
    return features?.includes(FeatureType.EDNA) || false;
};

/**
 * Check if a project has Habitat Insights feature
 */
export const hasHabitatInsightsFeature = (features: FeatureType[]): boolean => {
    return features?.includes(FeatureType.HLCA) || false;
};

/**
 * Check if a project has Survey feature
 */
export const hasSurveyFeature = (features: FeatureType[]): boolean => {
    return features?.includes(FeatureType.SURVEY) || false;
};

/**
 * Get human-readable display text for features array
 */
export const getFeaturesDisplayText = (features: FeatureType[]): string => {
    if (isBasicProject(features || [])) {
        return 'Starter (No features)';
    }
    const featureLabels: Record<FeatureType, string> = {
        [FeatureType.EDNA]: 'Species Insights',
        [FeatureType.HLCA]: 'Habitat Insights',
        [FeatureType.SURVEY]: 'Survey',
    };
    return (features || []).map(f => featureLabels[f] || f).join(', ');
};
